import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

const ContentPlain = ({ elementId, children, className }) => (
    <div id={elementId} className={classnames('content-plain', className)}>
            {children}
    </div>
)

ContentPlain.propTypes = {
    elementId: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    className: PropTypes.string
}

export default ContentPlain